var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46207 8.00124C8.50106 8.04027 8.50107 8.1035 8.4621 8.14255L4.94866 11.663C4.65606 11.9562 4.65653 12.4311 4.94972 12.7237C5.24291 13.0163 5.71778 13.0158 6.01038 12.7226L10.1233 8.60143C10.4159 8.30824 10.4155 7.83337 10.1223 7.54077C10.1213 7.5398 10.1203 7.53883 10.1193 7.53786L6.01012 3.42407C5.71739 3.13101 5.24251 3.13075 4.94946 3.42348C4.6564 3.71621 4.65614 4.19108 4.94887 4.48414L8.46207 8.00124Z",
    fill: "#B0B3BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.01baa8cb52e2be2d9070b619b0cbfce1.svg";
export { ForwardRef as ReactComponent };